module.exports = __webpack_public_path__ + "img/pr-7.e740bbd1.png";